module.exports = __webpack_public_path__ + "static/media/warning.6dfaa2f9.svg";